import { FC } from 'react';

export const IconError: FC = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM8.65035 9.35746L6.00391 6.71101L3.35746 9.35746L2.65035 8.65035L5.2968 6.00391L2.65035 3.35746L3.35746 2.65035L6.00391 5.2968L8.65035 2.65035L9.35746 3.35746L6.71101 6.00391L9.35746 8.65035L8.65035 9.35746Z"
      fill="#FF4343"
    />
  </svg>
);
